import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { useMenuRegistrationStore } from '../../hooks';
import { REGISTRATION_STEP } from '../../../../constants/registrationStep';
import { MenuRegistrationInputModalView } from './MenuRegistrationInputModalView';
import { MenuRegistrationConfirmModalView } from './MenuRegistrationConfirmModalView';
import { MenuRegistrationResultModalView } from './MenuRegistrationResultModalView';

type Props = ReturnType<typeof useMenuRegistrationStore>;

export const MenuRegistrationModalView: FC<Props> = ({
  isOpenModal,
  onCloseModal,
  onCloseModalWhenCompleted,
  currentModalStep,
  form,
  values,
  crawlers,
  menuCrawlers,
  onConfirm,
  onGoBack,
  onSubmit,
  onAddCrawler,
  onDeleteCrawler,
  onSortCrawler,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <MenuRegistrationInputModalView
        {...form}
        crawlers={crawlers}
        menuCrawlers={menuCrawlers}
        handleConfirm={onConfirm}
        handleAddCrawler={onAddCrawler}
        handleDeleteCrawler={onDeleteCrawler}
        handleSortCrawler={onSortCrawler}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <MenuRegistrationConfirmModalView
        values={values}
        crawlers={crawlers}
        menuCrawlers={menuCrawlers}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
        handleAddCrawler={onAddCrawler}
        handleDeleteCrawler={onDeleteCrawler}
        handleSortCrawler={onSortCrawler}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <MenuRegistrationResultModalView
        values={values}
        handleClose={onCloseModalWhenCompleted}
      />
    )}
  </Modal>
);
